/* ═══════════════════════════════════════════════════════════════
   ALTERLY — Studio App Status Bar
   Live telemetry: node/edge count, selection, GPU status, autosave.
   ═══════════════════════════════════════════════════════════════ */

import React from 'react';
import { useDomainBridge } from '../../stores/domainBridge';
import { useSelectionStore } from '../../stores/selectionStore';
import { useViewportStore } from '../../stores/viewportStore';
import { detectRendererCapabilities } from '../../rendering/capabilities';
import styles from './AppStatusBar.module.css';

export const AppStatusBar: React.FC = () => {
  const { domainState, saveStatus } = useDomainBridge();
  const { selectedNodeIds, selectedEdgeIds } = useSelectionStore();
  const { zoom } = useViewportStore();

  const nodeCount = Object.keys(domainState.canonical.nodes).length;
  const edgeCount = Object.keys(domainState.canonical.edges).length;
  const selectedCount = selectedNodeIds.size + selectedEdgeIds.size;
  const capabilities = detectRendererCapabilities();

  return (
    <footer className={styles.statusBar}>
      <div className={styles.metricsGroup}>
        <div className={styles.metricItem}>
          <span>Nodes:</span>
          <span className={styles.metricValue}>{nodeCount}</span>
        </div>

        <div className={styles.metricItem}>
          <span>Connections:</span>
          <span className={styles.metricValue}>{edgeCount}</span>
        </div>

        {selectedCount > 0 && (
          <div className={styles.metricItem}>
            <span>Selected:</span>
            <span className={styles.metricValue}>{selectedCount}</span>
          </div>
        )}

        <div className={styles.metricItem}>
          <span>Zoom:</span>
          <span className={styles.metricValue}>{Math.round(zoom * 100)}%</span>
        </div>
      </div>

      <div className={styles.metricsGroup}>
        <div className={styles.backendBadge}>
          {capabilities.webgl2 ? 'WebGL2 GPU Accelerated' : 'Canvas2D CPU Fallback'}
        </div>

        <div className={styles.saveIndicator}>
          <span className={saveStatus === 'saved' ? styles.saved : styles.dirty}>
            {saveStatus === 'saved' ? '● Saved' : '○ Unsaved edits'}
          </span>
        </div>
      </div>
    </footer>
  );
};
